export default {
  ratingScale: 5, // pms settings ratting scale default value is 5
  ratingDetails: [],
};
